window.onload= function(){
  clearSession("simulation_Step");
  document.querySelector("#step_0").show();

  let brutoSpans = document.querySelectorAll('span[data-source="param-maxBruto"]');
  let extraSpans = document.querySelectorAll('span[data-source="param-extraPerDependent"]');

  // Hide all substeps
  // The .each() method is unnecessary here:
  brutoSpans.forEach((element)=> {
    element.textContent = document.getElementById('maxBruto').value;
  });
  extraSpans.forEach((element)=> {
    element.textContent = document.getElementById('extraPerDependent').value;
  });
}

let firststepButtons = document.querySelectorAll('#gofirststep');
firststepButtons.forEach((element) =>{
  element.addEventListener("click",function () {
    clearSession("simulation_Step");
    document.querySelector("#step_0").hide();
    document.querySelector("#progress-indicator").show();
    document.querySelector("#step_1").show();
    document.querySelector("#step_2").hide();
    document.querySelector("#step_3").hide();
    document.querySelector("#step_4").hide();
    changeStep(1);
  });
});

let buttonsAnswers = document.querySelectorAll('[data-set-answer]');
buttonsAnswers.forEach((button) => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    let values = button.dataset.setAnswer.split(',');
    setAnswer(values[0], values[1]);
  });
});

let buttonsNextStep = document.querySelectorAll('[data-next-step]');
buttonsNextStep.forEach((button) => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    changeStep(button.dataset.nextStep, button);
  });
});

let buttonsSubStep = document.querySelectorAll('[data-sub-step]');
buttonsSubStep.forEach((button) => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    let values = button.dataset.subStep.split(',');
    changeSubStep(values[0], values[1]);
  });
});

function changeStep(step, element = null) {
  if (step == 3) {
    // Which form?
    let answerStep1 = sessionStorage.getItem("simulation_Step1");
    let answerStep2 = sessionStorage.getItem("simulation_Step2");
    if ((answerStep1 == 1 || answerStep1 == 2) && (answerStep2 == 1 || answerStep2 == 2 || answerStep2 == 3 || answerStep2 == 5)){
      changeSubStep(step,1);
    }
    if ((answerStep1 == 3 || answerStep1 == 4) && (answerStep2 == 1 || answerStep2 == 2 || answerStep2 == 3 || answerStep2 == 5)){
      changeSubStep(step,2);
    }
  } else if (step == 4) {
    // Check dates, show substep and do calculations if neccessary
    var form = element.closest('form');
    form.addEventListener('submit', function(e) {
      return false;
    })

    if (form.id === "toelagePerLiter"){
      // dateDelivery
      let dateform = new Date(form.elements['dateDelivery'].value);
      let today = new Date();
      // To calculate the time difference of two dates
      var Difference_In_Time = today.getTime() - dateform.getTime();
      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      if (form.checkValidity()) {
        if (Difference_In_Days > 60){
          changeSubStep(step, 1);
        } else {
          changeSubStep(step, 2);
          if (dateform.getFullYear() == today.getFullYear()){
            calculateResults(form.id, 1, form);
          }
          if (dateform.getFullYear() == (today.getFullYear()-1)){
            calculateResults(form.id, 2, form);
          }
        }
      } else {
        form.reportValidity();
        return;
      }
    }
    if (form.id === "toelageForfaitair"){
      // datePurchase
      let dateform = new Date(form.elements['datePurchase'].value);
      let today = new Date();
      // To calculate the time difference of two dates
      let Difference_In_Time = today.getTime() - dateform.getTime();
      // To calculate the no. of days between two dates
      let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      if (form.checkValidity()) {
        if (Difference_In_Days > 60) {
          changeSubStep(step, 3);
        }
        else {
          changeSubStep(step, 4);
          if (dateform.getFullYear() == today.getFullYear()){
            calculateResults(form.id, 1, form);
          }
          if (dateform.getFullYear() == (today.getFullYear()-1)){
            calculateResults(form.id, 2, form);
          }
        }
      } else {
        form.reportValidity();
        return;
      }
    }

  }
  else {
    // Step 1 or 2
    changeSubStep(step, 1);
  }

  let currentstep = step;

  for (let x = 1; x <= 4; x++) {
    if (document.querySelector('#linkStep' + x).getAttribute('aria-current', 'step')){
      document.querySelector('#linkStep' + x).removeAttribute('aria-current');
    }
    if (document.querySelector('#linkStep' + x).classList.contains('stepPast')){
      document.querySelector('#linkStep' + x).classList.remove('stepPast');
    }
    if (document.querySelector('#linkStep' + x).classList.contains('done')){
      document.querySelector('#linkStep' + x).classList.remove('done');
    }
    if (x < currentstep) {
      if (!document.querySelector('#linkStep' + x).classList.contains('stepPast')){
        document.querySelector('#linkStep' + x).classList.add('stepPast');
      }
      if (!document.querySelector('#linkStep' + x).classList.contains('done')){
        document.querySelector('#linkStep' + x).classList.add('done');
      }
    }
    document.querySelector("#step_" + x).hide();
  }

  document.querySelector('#linkStep' + step).setAttribute('aria-current', 'step');
  document.querySelector("#step_0").hide();
  document.querySelector("#progress-indicator").show();
  document.querySelector("#step_" + step).show();
  window.scrollTo(0, 0);
}

function calculateResults(mode, scenario, form){
  if (mode == "toelagePerLiter") {
    var ltrPast = form.elements['ltrPast'].value;
    var ltrNew = form.elements['ltrNew'].value;
    var pricePL = form.elements['pricePL'].value;
    var btwval = form.elements['priceBTW'].value;
    var priceTotal = form.elements['priceTotal'].value;
    var allPerLiterJson = "";

    if (!ltrPast) {
      ltrPast = 0;
    }

    if (scenario === 1) {
      allPerLiterJson = JSON.parse(document.getElementById('allPerLiterScaleN').value);
    } else {
      allPerLiterJson = JSON.parse(document.getElementById('allPerLiterScaleN-1').value);
    }

    document.getElementById("res-DateDelivery").textContent = new Date(form.elements['dateDelivery'].value).toLocaleDateString();
    document.getElementById("res-ltrPast").textContent = ltrPast;
    document.getElementById("res-ltrNew").textContent = ltrNew;

    /*      2 scenarios
          ▪ Scenario 1: <datum levering> is datum in jaar N => parameters set 1 zijn van toepassing voor berekeningen
          ▪ Scenario 2: <datum levering> is datum in jaar N-1 => parameters set 2 zijn van toepassing voor berekeningen.*/

    var maxLiters = 0;
    var allPerLiter = 0;
    var priceforstaffel = 0;

    /*excl btw*/
    if (btwval === "btwExcl"){
      priceforstaffel = parseFloat(pricePL * 1.21).toFixed(2);
    }

    /*incl btw*/
    if (btwval === "btwIncl"){
      priceforstaffel = parseFloat(pricePL * 1).toFixed(2);
    }

    allPerLiterJson.forEach((bracket)=> {

      let min = bracket.min;
      let max = bracket.max;
      let value = bracket.value;

      if ((priceforstaffel >= min) && (priceforstaffel < max)) {
        allPerLiter = value;
      }
    });

    if (scenario === 1){
      maxLiters = document.getElementById("maxLitersN").value;
    }

    if (scenario === 2){
      maxLiters = document.getElementById('maxLitersN-1').value;
    }

    let maxLitersSpans = document.querySelectorAll('span[data-source="param-maxliters"]');
    maxLitersSpans.forEach((element)=> {
      element.textContent = maxLiters;
    });

    let allPerLiterSpans = document.querySelectorAll('span[data-source="param-allPerLiter"]');
    allPerLiterSpans.forEach((element)=> {
      element.textContent = allPerLiter;
    });

    if (maxLiters - ltrPast < 0){
      document.getElementById("res-ltrVolumeAddon").textContent = "0";
      document.getElementById("res-VolumeAddon").textContent = "0";
      document.getElementById("res-Support").textContent = "0";
    }

    if (maxLiters - ltrPast > 0){
      var saldo = maxLiters - ltrPast;
      var litersVolume = 0;
      var resultGrant = 0;
      var resultSupportPercentage = 0;

      if (ltrNew > saldo){
        litersVolume = saldo;
      } else {
        litersVolume = ltrNew;
      }

      resultGrant = litersVolume * allPerLiter;
      resultSupportPercentage = (resultGrant / priceTotal) * 100;

      document.getElementById("res-ltrVolumeAddon").textContent = litersVolume;
      document.getElementById("res-VolumeAddon").textContent = Number(Number(resultGrant).toFixed(2));
      document.getElementById("res-Support").textContent = Number(Number(resultSupportPercentage).toFixed(2));
    }
  }
  if (mode == "toelageForfaitair"){
    var forfait = 0;
    var prevForfaitair = form.elements['prevForfaitair'].value;
    var prevPerLiter = form.elements['prevPerLiter'].value;

    if (prevForfaitair == "y" || prevPerLiter == "y") {
      /*  => go to 4-4-1 */
      document.querySelector("#step4-4-1").show();
      document.querySelector("#step4-4-2").hide();
    } else {
      /* => go to 4-4-2*/
      document.querySelector("#step4-4-2").show();
      document.querySelector("#step4-4-1").hide();

      let datePurchaseSpans = document.querySelectorAll('span[data-source="form-datePurchase"]');
      datePurchaseSpans.forEach((element)=> {
        element.textContent = form.elements['datePurchase'].value;
      });

      if (scenario == 1) {
        forfait = document.getElementById('forfaitN').value;
      }

      if (scenario == 2) {
        forfait = document.getElementById('forfaitN-1').value;
      }

      let forfaitSpans = document.querySelectorAll('span[data-source="param-Forfait"]');
      forfaitSpans.forEach((element)=> {
        element.textContent = forfait;
      });
    }
  }
}

function changeSubStep(mainstep, substep) {
  let searchids = "step" + mainstep + "-";
  let divs = document.querySelectorAll('div[id*=' + searchids + ']');

  // Hide all substeps
  // The .each() method is unnecessary here:
  divs.forEach((element)=> {
    element.hide();
  });

  // Show the given substep
  document.querySelector("#step" + mainstep + "-" + substep).show();

  // Scroll to top
  window.scrollTo(0, 0);
}

function setAnswer(step,chosenoption) {
  sessionStorage.setItem('simulation_Step'+step, chosenoption);
}


function clearSession(sesname){
  const regex = new RegExp(sesname+"*");
  let n = sessionStorage.length;
  while(n--) {
    let key = sessionStorage.key(n);
    if (regex.test(key)){
      sessionStorage.removeItem(key);
    }
  }
}

Element.prototype.hide = function(){
  this.style.display = 'none';
}
Element.prototype.show = function(){
  this.style.display = '';
}
